import { httpPost } from './request/index'

// 系统管理\考勤分析\列表  -- view
export function getSignList (data) {
  return httpPost('/cloud/cus/user/getSignList', data)
}

// 系统管理\考勤分析\打卡  -- view
export function getSignDetail (data) {
  return httpPost('/cloud/cus/user/getSignDetail', data)
}

// 系统管理\考勤分析\打卡月历  -- view
export function getSalaryDetail (data) {
  return httpPost('/cloud/cus/user/getSalaryDetail', data)
}
